import Helpers from '../../../../common/helpers/Helpers';
import Constants from '../../../../common/constants/Constants';

export const getSystemAlertConfigList = () => {
  return Helpers.get(Constants.SYSTEM_ALERT_CONFIG_LIST_URL);
};

export const updateSystemAlertConfig = (id, value, setting) => {
  let url = setting == "EmailNotifications" ? Constants.USER_ALERT_SETTINGS_UPDATE_URL :Constants.SYSTEM_ALERT_CONFIG_UPDATE_URL; 
  let params = {};
  params["ConfigFile"] = id;
  params[setting] = value;
  return Helpers.post(
    url,
    {},
    params
  );
};
